
import { H6 } from "../../../AbstractElements";
import { Link } from "react-router-dom";
import { Href } from "../../../utils/Constant";
import { Badge, Button } from "reactstrap";
import { Edit } from "react-feather";
import { Fragment } from "react/jsx-runtime";
import EditUserModal from "./EditUserModal";
import { useEffect, useState } from "react";
import { updateUserByAdminAction } from "../../../Api/auth";
import { toast } from "react-toastify";
import moment from "moment";

interface UsersTableBodyProps {
  users: any
  setUsers: (users: any) => void
}

const UsersTableBody: React.FC<UsersTableBodyProps> = ({ users = [], setUsers }) => {
  const [editUserModal, setEditUserModal] = useState(false)
  const [selectedId, setSelectedId] = useState("");

  const getSelectedUser = () => {
    return users.filter((user: any) => user.id === selectedId)[0];
  };
  
  const toggleActivateUser = async (userId: string) => {
    const selectedUser = users.filter((user: any) => user.id === userId)[0]
    const _status = selectedUser.status === "Active" ? "InActive" : "Active"
    const _user = {
      ...selectedUser, status: _status,
    }

    const response = await updateUserByAdminAction(_user)
    if (response.data && response.data.status === "success") {
      toast.success(selectedUser.status === "Active" ? "Deactivated User Successfully!" : "Activated User Successfully!");
      const _users = users.map((user: any) => {
        if (user.id === _user.id)
          return _user
        return user
      })
      setUsers(_users)
    }

    else {
      const _response: any = response
      if (_response?.response)
        toast.error(_response.response.data.message)
      else
        toast.error("Update failed!")
    }
  }
  return (
    <Fragment>
      <tbody>
        {users.map((user: any, i: any) => (
          <tr key={i}>
            <td>
              {i + 1}
            </td>
            <td>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <Link to={Href}>
                    <H6>{user.firstname}</H6>
                  </Link>
                </div>
              </div>
            </td>
            <td className="project-dot">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <H6>{user.lastname}</H6>
                </div>
              </div>
            </td>
            <td> {moment(user.created_at).format("YYYY-MM-DD")}</td>
            <td> {user.email}</td>
            <td><Badge color={`${user.role === "clinician" ? "primary" : "danger"}`}>{user.role}</Badge></td>
            <td><Badge className="text-uppercase" color={`${user.status === "Active" ? "primary" : "danger"}`}>{user.status}</Badge></td>
            <td>{user.pages_count}</td>
            <td>
              <div className="d-flex justify-content-center align-items-center" style={{ gap: '8px' }}>
                <Button
                  color={`secondary`}
                  className="d-flex align-items-center px-2 py-1"
                  style={{ gap: '4px' }}
                  onClick={() => {
                    setEditUserModal(true)
                    setSelectedId(user.id)
                  }}><Edit style={{ width: 16 }} />{"Edit"}</Button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
      <EditUserModal modal={editUserModal} setModal={setEditUserModal} user={getSelectedUser()} setUsers={setUsers} users={users}/>
    </Fragment>
  );
};

export default UsersTableBody;
